import electric from "../electrical.svg";
import lab from "../management.svg";
import meeting from "../meeting-room.svg";
import microscope from "../microscope.svg";
import secure from "../secure.svg";
import camera from "../security-camera.svg";
import warehouse from "../warehouse.svg";
import bin from "../recycle-bin.svg";
import fire from "../fire-extinguisher.svg";
import limbsSoftware from "../limbs-software.svg";


const locationInfrastructureData = [
  {
    id: 1,
    icon: electric,
    title: "Equipment management",
    description:
      "Key analytical equipments are supported by 21 CFR complainant software and UPS.",
    variant: "default",
  },
  {
    id: 2,
    icon: lab,
    title: "Laboratory Management",
    description:
      "Laboratory area residing clean room paneling with epoxy flooring, High efficiency particulate air (HEPA) and Air handling unit(AHU).",
    variant: "lab",
  },
  {
    id: 3,
    icon: limbsSoftware,
    title: "LIMS Software",
    description:
      "Our laboratory operations are fully integrated with Laboratory Information Management System (LIMS) software, enabling centralized data management, automated workflows, and regulatory compliance.",
    variant: "lab",
  },
  {
    id: 4,
    icon: microscope,
    title: "Instrumental Zone Management",
    description:
      "Whole Instrumental zone is connected to Variable Refrigerant Volume (VRV).",
    variant: "default",
  },
  {
    id: 5,
    icon: warehouse,
    title: "Storage Provision",
    description:
      "Quality modular furniture, Fume hood for working with chemicals, Separate storage facility for hazardous chemicals.",
    variant: "default",
  },
  {
    id: 6,
    icon: meeting,
    title: "Leisure And Discussion",
    description:
      "The facility of Digital library, Cafeteria and Well-furnished Conference room",
    variant: "default",
  },
  {
    id: 7,
    icon: secure,
    title: "Entry Restriction System",
    description: "Entry access control for inside lab area.",
    variant: "default",
  },
  {
    id: 8,
    icon: bin,
    title: "Waste Management",
    description:
      "Proper Waste segregation system for plastic waste, chemical hazards etc",
    variant: "default",
  },
  {
    id: 9,
    icon: fire,
    title: "Safety System",
    description: "Fire safety.",
    variant: "default",
  },
  {
    id: 10,
    icon: camera,
    title: "Surveillance Management",
    description: "CCTV Surveillance",
    variant: "default",
  },
];

export default locationInfrastructureData;